import { useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DEBOUNCE_DELAY } from "../../../pages/Annuaire/constant";
import { AVATAR_DEFAULT } from "../../../constants";
import { debounce } from "../../../utils/global";
import { useQuerySearchEmployee } from "../api/queries";

const useGlobalSearchEmployee = () => {
    const navigate = useNavigate();

    const [users, setUsers] = useState(""); // chaine envoyée au back (débouncée)
    const [searchQuery, setSearchQuery] = useState(""); // valeur affichée dans le champ (contrôlée)
    const blurResetPendingRef = useRef(false); // ignore le reset auto de Downshift au blur sans sélection

    const { all_users, isFetching, isLoading } = useQuerySearchEmployee({
        users,
    });

    const items = useMemo(() => {
        return (
            all_users?.map((el) => ({
                header: el?.first_name + " " + el?.last_name,
                image: el?.avatar || AVATAR_DEFAULT,
                content: el?.job_title || "/",
                id: el?.id,
                key: el?.id,
            })) ?? []
        );
    }, [all_users]);

    const debouncedSetUsers = useMemo(
        () =>
            debounce((value) => {
                setUsers(value?.length > 2 ? value : "");
            }, DEBOUNCE_DELAY),
        []
    );

    // input contrôlé : la valeur affichée change immédiatement, la requête part débouncée
    const handleSearchQueryChange = (value) => {
        if (blurResetPendingRef.current) {
            // Downshift réinitialise inputValue au blur si rien n'est sélectionné ;
            // on ignore ce reset pour conserver la recherche tapée par l'utilisateur.
            blurResetPendingRef.current = false;
            return;
        }
        setSearchQuery(value);
        debouncedSetUsers(value);
    };

    // le blur du dropdown (clic en dehors) précède le reset auto de Downshift
    const handleBlur = () => {
        blurResetPendingRef.current = true;
    };

    // on click item dropdown
    const onClickItem = (e, data) => {
        if (data?.value?.id) {
            navigate(`/employee/${data.value.id}`);
        }
    };

    return {
        states: {
            searchQuery,
            items,
        },
        query: {
            all_users,
            isLoading,
            isFetching,
        },
        functions: {
            handleSearchQueryChange,
            handleBlur,
            onClickItem,
        },
    };
};

export default useGlobalSearchEmployee;
